module.exports = __webpack_public_path__ + "frontend/images/homepage/slider/card-2@2.jpg?eb5999091128fabc2730c01836bbcfa7";